export default __webpack_public_path__ + "static/media/services_food.74d9d077.jpg";